module.exports = __webpack_public_path__ + "img/fisip.81d61627.svg";